var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { getGameRefParameter, getLobbyIdParameter, getParameter } from "./getParameter";
import { deepMergeLayerConfig } from "./utils/deepMergeLayerConfig";
export let layerConfig = {
    modules: [],
    modulePath: "",
    translationApiUrl: ""
};
const createRequestParameters = () => {
    var _a, _b, _c, _d;
    const partnerid = getParameter("partnerid");
    if (partnerid === null || partnerid === "") {
        return {
            host: window.location.hostname
        };
    }
    const api = getParameter("api");
    const channel = getParameter("channel");
    const tester = getParameter("tester");
    const integration = getParameter("integration");
    const apexmodules = getParameter("apexmodules");
    const excludefrompromo = getParameter("excludefrompromo");
    const parameters = Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({ gameref: (_b = (_a = getGameRefParameter()) !== null && _a !== void 0 ? _a : getLobbyIdParameter()) !== null && _b !== void 0 ? _b : "", partnerid, jurisdiction: (_c = getParameter("jurisdiction")) !== null && _c !== void 0 ? _c : "", moneymode: (_d = getParameter("moneymode")) !== null && _d !== void 0 ? _d : "real" }, api !== null && { api }), channel !== null && { channel }), tester !== null && { tester }), integration !== null && { integration }), apexmodules !== null && { apexmodules }), excludefrompromo !== null && { excludefrompromo });
    return parameters;
};
export const fetchLayerConfig = (pathConfig) => __awaiter(void 0, void 0, void 0, function* () {
    let layerConfigUrlOverride = null;
    if (process.env.MODE === "development") {
        const layerConfigOverride = getParameter("layerconfig");
        if (layerConfigOverride !== null) {
            try {
                const parsed = JSON.parse(layerConfigOverride);
                layerConfig = parsed;
                return parsed;
            }
            catch (error) {
                console.error("Layer config override is not valid JSON.", error);
            }
        }
        layerConfigUrlOverride = getParameter("layerconfigurl");
    }
    const layerConfigUrl = layerConfigUrlOverride !== null && layerConfigUrlOverride !== void 0 ? layerConfigUrlOverride : pathConfig.layerconfigurl;
    const params = new URLSearchParams(createRequestParameters());
    const response = yield fetch(layerConfigUrl + "?" + params.toString());
    const STATUS_OK = 200;
    if (response.status !== STATUS_OK) {
        throw new Error(`getLayerConfig fetch failed (status ${response.status.toString()})`);
    }
    const responseData = yield response.json().catch((error) => {
        if (error instanceof Error) {
            throw new Error("Error parsing LayerConfig: " + error.message);
        }
    });
    if (process.env.MODE === "development") {
        const partialLayerConfigOverride = getParameter("amendlayerconfig");
        if (partialLayerConfigOverride !== null) {
            try {
                const parsed = JSON.parse(partialLayerConfigOverride);
                const merged = deepMergeLayerConfig(responseData, parsed);
                layerConfig = merged;
                console.log("Partial LayerConfig override", merged);
                return merged;
            }
            catch (error) {
                console.error("Layer config replace is not valid JSON.", error);
            }
        }
    }
    layerConfig = responseData;
    return responseData;
});
